module.exports = __webpack_public_path__ + "static/media/answerChoose.54994c30.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/answerChoose.png
// module id = 1714
// module chunks = 0 1